<div class="device-data-loader">
  <app-loader [loading]="true"></app-loader>
  <h2>{{ 'page.login.redirecting' | translate }}</h2>
</div>
